import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import FruitDetailPage from './pages/FruitDetailPage';
import CategoryPage from './pages/CategoryPage';
import SearchPage from './pages/SearchPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main className="site-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/fruit/:fruitId" element={<FruitDetailPage />} />
            <Route path="/categories/:categoryType" element={<CategoryPage />} />
            <Route path="/search" element={<SearchPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
